export default __webpack_public_path__ + "static/media/Strengthening_Adolescent-Responsive_Health_Systems.2b2d492a.png";